// extracted by mini-css-extract-plugin
module.exports = {"div":"Announcements_div__WvhdP"};